import React, { useState } from 'react';
import { useEvent } from './use-event';

interface EventConsumerProps {
  event: string;
  children: (data: any) => React.ReactNode;
}

export const EventConsumer: React.FC<EventConsumerProps> = ({ event, children }) => {
  const [data, setData] = useState<any>(null);

  useEvent(event, setData);

  return <>{children(data)}</>;
};
